<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">推广成本导入(按国家细分)</h1>
    <div class="h_search">
      <label>
        渠道：
        <el-select v-model="search.channel" placeholder="请选择" clearable>
          <el-option
            v-for="(item, ind) in channelList"
            :key="ind"
            :label="item"
            :value="item"
          >
          </el-option> </el-select
      ></label>
      <label
        >平台：
        <el-select v-model="search.medium" placeholder="请选择" clearable>
          <el-option
            v-for="(item, ind) in mediumList"
            :key="ind"
            :label="item"
            :value="item"
          >
          </el-option> </el-select
      ></label>
      <el-upload
        class="avatar-uploader"
        action=""
        :auto-upload="false"
        :show-file-list="false"
        :on-change="addExcel"
        ref="upload"
      >
        <el-button type="danger" v-loading="loading2">导入excel</el-button>
      </el-upload>
      <el-button type="primary" @click="query" :loading="loading">
        刷新
      </el-button>
    </div>
    <el-table :data="tableList" v-loading="loading">
      <el-table-column prop="channel" label="渠道"> </el-table-column>
      <el-table-column prop="medium" label="平台" sortable> </el-table-column>
      <el-table-column prop="costMoney" label="成本"> </el-table-column>
      <el-table-column prop="createDate" label="创建时间" sortable>
      </el-table-column>
      <el-table-column prop="operator" label="操作人"> </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="showMore(scope.row.detailList)"
            >成本</el-button
          >
          <el-button type="danger" size="mini" @click="del(scope.row.onlyId)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrent"
      :current-page.sync="pageInfo.page"
      :page-size="pageInfo.pageSize"
      layout="total, prev, pager, next, jumper"
      :total="pageInfo.total"
    >
    </el-pagination>
    <el-dialog
      title="成本"
      :visible.sync="dialog"
      width="60%"
      :before-close="handleClose"
    >
      <el-table :data="dataList">
        <el-table-column prop="date" label="数据日期"> </el-table-column>
        <el-table-column prop="channel" label="渠道"> </el-table-column>
        <el-table-column prop="countryCode" label="国家"> </el-table-column>
        <el-table-column prop="monetaryUnit" label="货币单位">
        </el-table-column>
        <el-table-column prop="costMoney" label="成本"> </el-table-column>
        <el-table-column prop="medium" label="平台"> </el-table-column>
        <el-table-column prop="createDate" label="创建时间"> </el-table-column>
        <el-table-column prop="operator" label="操作人"> </el-table-column>
      </el-table>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      tableList: [],
      dataList: [],
      dialog: false,
      search: { channel: '', medium: '' },
      pageInfo: { page: 1, pageSize: 30, total: 0 },
      channelList: [],
      mediumList: ['google', 'facebook'],
      loading: false,
      loading1: false,
      loading2: false
    }
  },
  beforeCreate() {},
  created() {
    this.query()
    this.channel_query()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    query() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.promotion_cost_query,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          page: this.pageInfo.page
        }
      })
        .then(
          res => {
            this.loading = false
            if (res.data.code === 0) {
              this.tableList = res.data.data.data
              this.pageInfo.total = res.data.data.total
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.loading = false
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    channel_query() {
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.ad_cost_channel,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.channelList = res.data.data.data
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.loading = false
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    del(id) {
      this.$confirm('确认删除此成本纪录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$axios({
          type: 'GET',
          url: this.$store.getters.path.promotion_cost_del,
          withCredentials: true,
          params: {
            username: this.username,
            token: this.token,
            onlyId: id
          }
        })
          .then(
            res => {
              this.loading1 = false
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success'
                })

                this.query()
              } else if (res.data.code === 1001) {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error'
                })
                this.$router.push(this.$route.query.redirect || '/login')
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error'
                })
              }
            },
            err => {
              this.loading1 = false
              this.$message({
                showClose: true,
                message: '请求错误:' + err,
                type: 'error'
              })
            }
          )
          .then(() => {
            this.loading1 = false
          })
      })
    },
    addExcel(file) {
      if (this.search.channel == '' || this.search.medium == '')
        return this.$message('渠道和平台必填')
      this.$confirm('确认', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.loading2 = true
          const formdata = new FormData()
          formdata.append('file', file.raw)
          formdata.append('channel', this.search.channel)
          formdata.append('medium', this.search.medium)
          const { data: res } = await this.$axios.post(
            this.$store.getters.path.promotion_cost_excel_import_data +
              '?username=' +
              this.$store.getters.username +
              '&token=' +
              this.$store.getters.token,
            formdata
          )
          this.loading2 = false
          this.query()
          this.$refs.upload.clearFiles()
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          } else {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            })
          }
        })
        .catch(() => {
          this.$refs.upload.clearFiles()
        })
    },
    showMore(list) {
      this.dialog = true
      this.dataList = list
    },
    handleCurrent(val) {
      this.pageInfo.page = val
      this.query()
    },
    handleClose() {
      this.dataList = []
      this.dialog = false
    }
  }
}
</script>
